import { SkuTypeForDrilldown } from './drillDownLib';
import React, { useCallback } from 'react';
import { Button } from '@ydistri/ds';

interface SkuTypeButtonProps {
  skuType: SkuTypeForDrilldown;
  selected: boolean;
  onSkuTypeClick: (skuType: SkuTypeForDrilldown) => void;
}

export const SkuTypeButton: React.FC<SkuTypeButtonProps> = ({
  skuType,
  selected,
  onSkuTypeClick,
}) => {
  const handleClick = useCallback(() => onSkuTypeClick(skuType), [onSkuTypeClick, skuType]);

  return (
    <Button
      $colorVariant={selected ? 'selected' : 'ghost'}
      $textVariant="semibold"
      onClick={handleClick}
      data-type="drill-down-sku-type-button"
    >
      {skuType === 'total' ? 'All' : skuType}
    </Button>
  );
};
